<template>
<div class="chapter">
<div class="inner_page">
<p class="ach">Also by Joe Keenan</p>
<p class="acsh"><em>Blue Heaven</em></p>
<p class="acl"><em>Putting on the Ritz</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MyLuckyStar_adca-1.vue?0c6b62b1